<div class="create-role">
  <div class="column">
    @for (privilege of filteredPrivileges[0]; track privilege.id) {
      <andor-mat-toggle-wrapper
        label="{{ privilege.label | translate }}"
        tooltipText="{{ privilege.description | translate }}">
        <mat-slide-toggle
          [disabled]="isDisabled(privilege.id)"
          (toggleChange)="onToggle(privilege.id)"
          [checked]="isDisabled(privilege.id) ? false : privileges()[privilege.id]"></mat-slide-toggle>
      </andor-mat-toggle-wrapper>
    }
  </div>
  <div class="column">
    @for (privilege of filteredPrivileges[1]; track privilege.id) {
      <andor-mat-toggle-wrapper
        label="{{ privilege.label | translate }}"
        tooltipText="{{ privilege.description | translate }}">
        <mat-slide-toggle
          [disabled]="isDisabled(privilege.id)"
          (toggleChange)="onToggle(privilege.id)"
          [checked]="isDisabled(privilege.id) ? false : privileges()[privilege.id]"></mat-slide-toggle>
      </andor-mat-toggle-wrapper>
    }
  </div>
</div>
